import React, { Component } from "react";

export interface InputNumberProps {
    field?: any;
    form?: any;
}

export default class InputNumber extends Component<InputNumberProps, {}> {
    useSignal: string;
    prohibitSignal: string;
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props) {
        super(props);
        this.inputRef = React.createRef();

        this.useSignal =
            navigator.userAgent.indexOf("Firefox") !== -1 ? "." : ",";
        this.prohibitSignal =
            navigator.userAgent.indexOf("Firefox") !== -1 ? "," : ".";
    }

    countDecimalsPlaces = value => {
        let testValue = value
            .toString()
            .replace(this.prohibitSignal, this.useSignal);
        if (Math.floor(testValue) !== testValue) {
            let splited = testValue.split(this.useSignal);
            return splited[splited.length - 1].length || 0;
        }
        return 0;
    };

    isInteger = valueTest => {
        return (
            typeof valueTest === "number" &&
            isFinite(valueTest) &&
            Math.floor(valueTest) === valueTest
        );
    };

    render() {
        const fieldName = this.props.field.name;

        const errorMessage =
            this.props.form.errors[fieldName] != "Field is required."
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                  this.props.form.errors[fieldName];

        return (
            <div
                id="input"
                className={`${
                    errorMessage !== undefined && errorMessage.length > 0
                        ? "input-group-error"
                        : ""
                }`}
            >
                <input
                    type="number"
                    className="input"
                    spellCheck={false}
                    ref={this.inputRef}
                    step={fieldName.includes("contribution") ? "0.01" : "1"}
                    value={this.props.field.value || ""}
                    {...this.props.field}
                    {...this.props}
                    /*onKeyDown={evt => {
                        if (evt.nativeEvent.key === this.prohibitSignal) {
                            evt.nativeEvent.preventDefault();
                        }
                    }}*/
                    onChange={(...args) => {
                        /*if (
                            (args[0].target.value.match(/\./g) || []).length >
                                1 ||
                            (args[0].target.value &&
                                args[0].target.value[0] == this.useSignal)
                        ) {
                            args[0].nativeEvent.preventDefault();
                        } else {
                            if (
                                !isNaN(parseFloat(args[0].target.value)) &&
                                !this.isInteger(
                                    parseFloat(args[0].target.value)
                                ) &&
                                this.countDecimalsPlaces(
                                    parseFloat(args[0].target.value)
                                ) > 2
                            ) {
                                let excess =
                                    this.countDecimalsPlaces(
                                        parseFloat(args[0].target.value)
                                    ) - 2;

                                this.inputRef.current.value = args[0].target.value
                                    .toString()
                                    .slice(0, -excess);
                            } else {*/
                        const { field } = this.props;
                        let { touched } = this.props.form;
                        touched[field.name] = true;
                        this.props.form.setTouched(touched);
                        field.onChange(...args);
                        //}
                        //}
                    }}
                />
                <span className="input-error">
                    {errorMessage !== undefined &&
                        errorMessage.length > 0 &&
                        errorMessage}
                </span>
            </div>
        );
    }
}
